/**
 * API base URL (docs/17_API_STANDARDS.md; `.env.example`'s
 * `VITE_API_BASE_URL`). Falls back to the same relative path the Vite dev
 * proxy already targets, so the app still works if the variable is unset.
 */
export const API_BASE_URL: string =
  (import.meta.env['VITE_API_BASE_URL'] as string | undefined) ?? '/api/v1';
